<template>
    <form @submit.prevent="editData($event)">
        <b-card class="">
            <b-row>
                <b-col  :md="6">
    

                    <label class="sr-only" for="inline-form-input-name">نام</label>
                    <b-form-input name="name" :value="info.name" id="inline-form-input-name"
                        class="mb-2 mr-sm-2 mb-sm-0"></b-form-input>
                    <br>
                    
                </b-col>
                <b-col style="padding-top: 2%;"  :md="6">
         
                        <label class="sr-only" for="inline-form-input-name"> افزودن همه &nbsp;</label>
                        <a-switch id="selectAll" v-model="selectAll" name="fullAccess" />



                </b-col>
                <br>
            </b-row>
            <b-row>
                <b-col style="padding-bottom:50px;" :md="4" v-for="(row,key) in permissions">
                    <h6>*{{ row . title }}
                    </h6>
                    <div v-for="(access,index) in row.access">

                        <b-form-checkbox :name="'access[' + key + '][' + index + ']'" value="1">&nbsp;
                            {{ access }} &nbsp; </b-form-checkbox>

                    </div>
                </b-col>
                <br>
            </b-row>
            <button type="submit" class="btn btn-fill btn-success">
                ذخیره
            </button>
        </b-card>

    </form>

</template>

<script>
    export default {
        data() {
            return {
                permissions: [],
                access: [],
                selectAll: false,
                info: {},
                checked: [],

            };
        },
        methods: {
            async getData() {
                let _this = this;
                let url = `/roles/permissions`;
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.permissions = response.data;
                                    _this.getInfo();

                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },
            async getInfo() {
                let _this = this;
                let url = `/roles/single/${this.$route.params.id}`;
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.info = response.data.data;
                        _this.checked = JSON.parse(_this.info.permissions);
                        _this.isChecked();
                    })
                    .catch(function(err) {
                        console.log("erroooooooooooooooooooooooooooooooooooooooooooooor")
                        console.log(err)
                        // location.reload()
                        _this.$root.handleAxiosError(err);
                    });
            },
            editData(event) {
                let _this = this;
                let data = new FormData(event.target);
                _this.$root.loading = true;
                let url = `/roles/edit/${this.$route.params.id}`;

                axios
                    .post(url, data)
                    .then(function(response) {
                        _this.$root.loading = false;
                        _this.$toast.success("سطح دسترسی با موفقیت ویرایش شد");
                        _this.$router.push("/roles/list");
                    })
                    .catch(function(err) {
                        _this.$root.loading = false;
                        _this.$root.handleAxiosError(err);
                    });
            },
            isChecked() {
                let keys = Object.keys(this.checked);
                for (var i = 0, n = keys.length; i < n; i++) {
                    let indexes = Object.keys(this.checked[keys[i]]);
                    for (var j = 0; j < indexes.length; j++) {
                        if(document.getElementsByName(`access[${keys[i]}][${indexes[j]}]`)[0]){
                        document.getElementsByName(`access[${keys[i]}][${indexes[j]}]`)[0].checked=true

                        }
                    }
                }
            }
        },
        mounted() {
            this.getData();
        },
        
        watch: {
            selectAll() {
                let checkboxes = document.getElementsByTagName('input');
                for (var i = 0, n = checkboxes.length; i < n; i++) {
                    checkboxes[i].checked = this.selectAll;
                }

            },
           
        }
    };
</script>

<style scope>

</style>
